//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "pc-header",
  methods: {
    handleToWeb () {
      location.href = 'https://pc.dnaer.tv/#/'
    },
    handleToCommunity () {
      this.$router.push({name: 'community'})
    },
    handleToUser () {
      this.$router.push({name: 'userProtocol'})
    },
    handleToPricacy () {
      this.$router.push({name: 'privacy'})
    },
    handleToHome () {
      this.$router.push({name: 'home'})
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/common/pcHeader.vue